import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from 'date-fns';

const money = (v) => `Rs. ${(Number(v) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export function downloadInvoicePdf(dispatch) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const left = 48;
  let y = 52;

  doc.setFillColor(245, 158, 11);
  doc.rect(0, 0, pageWidth, 8, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(30, 30, 30);
  doc.text('Evabrew Roastery', left, y);
  doc.setFontSize(20);
  doc.setTextColor(245, 158, 11);
  doc.text('INVOICE', pageWidth - left, y, { align: 'right' });
  y += 28;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(90, 90, 90);
  doc.text(`Invoice No: ${dispatch.invoice_no || '-'}`, pageWidth - left, y, { align: 'right' });
  doc.text(`Date: ${format(new Date(dispatch.dispatch_date), 'dd MMM yyyy')}`, pageWidth - left, y + 14, { align: 'right' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(120, 120, 120);
  doc.text('BILL TO', left, y);
  doc.setFontSize(13);
  doc.setTextColor(30, 30, 30);
  doc.text(dispatch.client_name || 'Walk-in / Unnamed', left, y + 17);
  y += 44;

  const items = dispatch.items || [];
  const itemLabel = (it) =>
    it.blend_name ||
    (it.components?.length
      ? it.components.map((c) => c.category_name).join(' + ')
      : `${it.category_name} (${it.roast_level})`);
  autoTable(doc, {
    head: [['#', 'Item', 'Qty (kg)', 'Rate / kg', 'Amount']],
    body: items.map((it, i) => [
      i + 1,
      itemLabel(it),
      Number(it.quantity_kg).toFixed(2),
      money(it.sale_price_per_kg),
      money(it.quantity_kg * it.sale_price_per_kg),
    ]),
    startY: y,
    margin: { left, right: left },
    styles: { fontSize: 10, cellPadding: 7 },
    headStyles: { fillColor: [245, 158, 11], textColor: 255 },
    alternateRowStyles: { fillColor: [252, 250, 245] },
    columnStyles: { 0: { cellWidth: 26 }, 2: { halign: 'right' }, 3: { halign: 'right' }, 4: { halign: 'right' } },
  });
  y = doc.lastAutoTable.finalY + 18;

  const total = dispatch.total_sale_value || 0;
  const paid = dispatch.amount_paid || 0;
  const balance = total - paid;
  const rightCol = pageWidth - left;
  const lineRow = (label, value, bold = false, color = [30, 30, 30]) => {
    doc.setFont('helvetica', bold ? 'bold' : 'normal');
    doc.setFontSize(bold ? 12 : 10);
    doc.setTextColor(...color);
    doc.text(label, rightCol - 170, y);
    doc.text(value, rightCol, y, { align: 'right' });
    y += bold ? 20 : 16;
  };
  lineRow('Total Quantity', `${(dispatch.total_quantity_kg || 0).toFixed(2)} kg`);
  lineRow('Subtotal', money(total), true);
  lineRow('Amount Paid', money(paid), false, [16, 128, 82]);
  lineRow('Balance Due', money(balance), true, balance > 0 ? [200, 40, 40] : [16, 128, 82]);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  const status = dispatch.payment_status || 'Unpaid';
  const statusColor = status === 'Paid' ? [16, 128, 82] : status === 'Partial' ? [200, 130, 0] : [200, 40, 40];
  doc.setTextColor(...statusColor);
  doc.text(`Payment Status: ${status.toUpperCase()}`, left, y - 30);

  if (dispatch.notes) {
    y += 8;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(110, 110, 110);
    doc.text(`Notes: ${dispatch.notes}`, left, y, { maxWidth: pageWidth - left * 2 });
  }

  doc.setFontSize(8);
  doc.setTextColor(160, 160, 160);
  doc.text('Generated by Evabrew Roastery Management', left, doc.internal.pageSize.getHeight() - 28);

  doc.save(`invoice_${(dispatch.invoice_no || dispatch.id).replace(/[^a-zA-Z0-9-]/g, '_')}.pdf`);
}
